import {
  ArrowRightOnRectangleIcon,
  EnvelopeIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import { Button } from '../../components/Button';

interface AccountSecuritySectionProps {
  email: string;
  onChangeEmail: () => void;
  onSignOut: () => void;
}

/**
 * Presentational component for account security settings.
 * Shows email change and sign out options.
 */
export const AccountSecuritySection = ({
  email,
  onChangeEmail,
  onSignOut,
}: AccountSecuritySectionProps) => {
  return (
    <div className="bg-surface rounded-3xl shadow-xl border border-subtle overflow-hidden">
      <div className="px-6 py-5 border-b border-subtle flex items-center bg-muted/50">
        <ShieldCheckIcon className="h-6 w-6 text-brand mr-3" />
        <h3 className="text-lg font-bold text-main">Account Security</h3>
      </div>

      <div className="p-6 space-y-6">
        {/* Email Section */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl bg-surface border border-default hover:border-brand transition-colors group">
          <div className="flex items-start space-x-4 mb-4 sm:mb-0">
            <div className="p-2 bg-info-subtle rounded-lg group-hover:bg-info-subtle transition-colors">
              <EnvelopeIcon className="h-6 w-6 text-info" />
            </div>
            <div>
              <p className="text-sm font-medium text-main">Email Address</p>
              <p className="text-sm text-muted mt-1 break-all">{email}</p>
            </div>
          </div>
          <Button type="button" variant="secondary" onClick={onChangeEmail}>
            Change Email
          </Button>
        </div>

        {/* Sign Out Section */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl bg-surface border border-default hover:border-brand transition-colors group">
          <div className="flex items-start space-x-4 mb-4 sm:mb-0">
            <div className="p-2 bg-subtle rounded-lg group-hover:bg-subtle transition-colors">
              <ArrowRightOnRectangleIcon className="h-6 w-6 text-brand" />
            </div>
            <div>
              <p className="text-sm font-medium text-main">Sign Out</p>
              <p className="text-sm text-muted mt-1">Sign out of your account on this device</p>
            </div>
          </div>
          <Button type="button" variant="secondary" onClick={onSignOut}>
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};
